import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router'
import { withIonLifeCycle } from '@ionic/react'
import { setLoginNew } from '../../store/LoginNew/loginNew.slice'
import { connectCasinoProvider } from '../CasinoProvider/CasinoProvider.connect'
import SlotsCasinoPopUp from '../../components/SlotsCasinoPopup'

const GapcasinoProvider = ({ actions, auth, slotCasinoPopUp }) => {
  const dispatch = useDispatch()
  const history = useHistory()

  const gapCasinoList = useSelector((state) => state.liveCasino.gapCasinoList)

  const [loading, setLoading] = useState(false)
  const [selectedIndex, setSelectedIndex] = useState('MAC88')
  const [page, setPage] = useState(1)
  const [hasMore, setHasMore] = useState(true)
  const [games, setGames] = useState([])

  const loaderRef = useRef(null)

  const tapData = [
    // 'All',

    'MAC88',
    'RG',
    'EZUGI',
    'GAPLOBBY',
    'JACKTOP',
    'DC',
    'BETCORE',
    'CREED',
    'AWC',
    'KINGMIDAS',
    'BETGAMES',
    'SUNO',
    'CRASH88',
    'SAP',
    'TURBO',
    'JiLi',
    'DRGS',
    'MACAW',
    'MARBLES',
    'SPRIBE',

    'RICH88',
  ]

  // ---------------- FETCH GAMES ----------------
  const getGapGameList = (pageNo = 1) => {
    if (loading || !hasMore) return

    const provider = selectedIndex !== 'All' ? selectedIndex : undefined
    setLoading(true)

    actions.gamesListGap(pageNo, provider)
  }

  // ---------------- RESET ON TAB CHANGE ----------------
  useEffect(() => {
    setPage(1)
    setGames([])
    setHasMore(true)
    getGapGameList(1)
  }, [selectedIndex])

  // ---------------- LOAD NEXT PAGE ----------------
  useEffect(() => {
    if (page > 1) {
      getGapGameList(page)
    }
  }, [page])

  // ---------------- UPDATE LOCAL LIST FROM REDUX ----------------
  useEffect(() => {
    if (!gapCasinoList?.data) return

    setGames((prev) => [...prev, ...gapCasinoList.data])

    if (gapCasinoList.data.length === 0) {
      setHasMore(false)
    }

    setLoading(false)
  }, [gapCasinoList])

  // ---------------- INFINITE SCROLL OBSERVER ----------------
  useEffect(() => {
    if (!loaderRef.current) return

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && hasMore && !loading) {
          setPage((prev) => prev + 1)
        }
      },
      {
        root: null,
        rootMargin: '100px',
        threshold: 0,
      }
    )

    observer.observe(loaderRef.current)

    return () => observer.disconnect()
  }, [hasMore, loading])

  // ---------------- GAME CLICK ----------------
  const onSelectGame = (data) => {
    if (!data?.game_id) return

    if (auth) {
      history.push(
        `/gap-casino/${data.game_id}/${data?.category}/${data?.provider_name}`
      )
    } else {
      dispatch(setLoginNew(true))
    }
  }

  return (
    <div className="casino-provider-container">
      {slotCasinoPopUp && <SlotsCasinoPopUp />}
      {/* ---------------- PROVIDER TABS ---------------- */}
      <div className="casino-provider-header-list">
        <ul className="nav nav-pills" role="tablist">
          {tapData.map((item) => (
            <li className="nav-item" key={item}>
              <a
                href="#"
                className={`nav-link ${
                  selectedIndex === item ? 'selected' : ''
                }`}
                onClick={(e) => {
                  e.preventDefault()
                  setSelectedIndex(item)
                }}
              >
                {item}
              </a>
            </li>
          ))}
        </ul>
      </div>

      {/* ---------------- GAME LIST ---------------- */}
      <div className="casino-games-container">
        {games.map((item) => (
          <div
            className="casino-game-box"
            key={item.game_id}
            onClick={() => onSelectGame(item)}
          >
            <div className="casino-icon-box">
              <img src={item.url_thumb} alt={item.game_name} />
              <div className="casino-name">PLAY NOW</div>
            </div>
          </div>
        ))}
      </div>

      {/* ---------------- LOADER TRIGGER ---------------- */}
      <div ref={loaderRef} style={{ height: 40 }} />

      {/* ---------------- SPINNER ---------------- */}
      {loading && (
        <div className="spinner-container">
          <svg className="spinner" width="65" height="65" viewBox="0 0 66 66">
            <circle
              className="path"
              fill="none"
              strokeWidth="6"
              strokeLinecap="round"
              cx="33"
              cy="33"
              r="30"
            />
          </svg>
        </div>
      )}
    </div>
  )
}

export default withIonLifeCycle(connectCasinoProvider()(GapcasinoProvider))
